// ts-rest contract for the saved dashboard layouts (SEP-296).
//
// Three routes for one surface: read, save and delete. No route takes a user
// id. The server reads the identity of the caller, and it refuses a surface
// that the active persona of the caller does not own.

import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { errorBody } from '../schemas/common';
import {
    dashboardLayoutReadSchema,
    dashboardSurfaceSchema,
    deleteDashboardLayoutResponseSchema,
    putDashboardLayoutBodySchema,
} from '../schemas/dashboard-layout';

const c = initContract();

const surfaceParams = z.object({ surface: dashboardSurfaceSchema });

export const dashboardLayoutContract = c.router(
    {
        get: {
            method: 'GET',
            path: '/dashboard-layout/:surface',
            pathParams: surfaceParams,
            responses: {
                200: dashboardLayoutReadSchema,
                400: errorBody,
                403: errorBody,
            },
            summary: 'The saved layout of one dashboard for the caller',
        },
        put: {
            method: 'PUT',
            path: '/dashboard-layout/:surface',
            pathParams: surfaceParams,
            body: putDashboardLayoutBodySchema,
            responses: {
                200: dashboardLayoutReadSchema,
                400: errorBody,
                403: errorBody,
            },
            summary: 'Save the layout of one dashboard for the caller',
        },
        delete: {
            method: 'DELETE',
            path: '/dashboard-layout/:surface',
            pathParams: surfaceParams,
            body: z.object({}).optional(),
            responses: {
                200: deleteDashboardLayoutResponseSchema,
                400: errorBody,
                403: errorBody,
            },
            summary: 'Delete the saved layout of one dashboard for the caller',
        },
    },
    { pathPrefix: '/api', strictStatusCodes: false },
);
